// Uses W3C's official email regex (the same used when validating type="email" on an input)
// https://www.w3.org/TR/2012/WD-html-markup-20120320/input.email.html
// Added end matching group to validate two dot domains eg ".co.uk"
const emailRegexToEndAll = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)?\.+[a-z0-9](?:[a-z0-9-]*[a-z0-9])$/;

// source: https://stackoverflow.com/a/16699507
const phoneRegex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

export const validateEmail = email => {
  return emailRegexToEndAll.test(email);
};

export const validatePhone = phone => {
  return phoneRegex.test(phone);
};

export const validateNumber = number => {
  if (typeof number !== 'string' && typeof number !== 'number') return false;
  return !isNaN(number);
};
